module.exports = "/_next/static/images/e25638603994d0a3d4bb9647f0ceefe5-blog-lg-1x.jpg";